// Las tarjetas de Mis comisiones: el borde, el fondo y el título de cada sección.
export const CARD = 'rounded-xl border border-border bg-card p-4';
export const TITLE = 'mb-2 text-[10px] font-bold uppercase tracking-[0.08em] text-muted-foreground';
